import { TopConfig } from '../context/ConfigContext';
import axios, { AxiosResponse } from 'axios';
import { WorkshopData } from '../types/services';

export type supplierParams = {
    businessArea: string;
    q: string;
    brand: string;
    damageSize: string;
};

export const supplierService = async (topConfig: TopConfig, params: supplierParams) => {
    const { url, headers, method } = topConfig.services.suppliers;

    if (!url) {
        throw new Error('Supplier service: Url not defined');
    }
    try {
        const response: AxiosResponse<WorkshopData> = await axios(url, {
            method,
            headers,
            params
        });

        return response.status === 200 ? response.data : null;
    } catch {
        // @TODO
        //  - Log that vehicle service malfunctioned
        return null;
    }
};
